import { useMemo, type ReactNode } from "react";

import { IconCalendarSchedule, IconUser } from "@synthesis/shared-icons";
import { UserInformation, type UserInformationUser } from "@synthesis/shared-ui";

import { NotificationBody } from "../local-components/notification-body";

type InfoItem = {
  icon?: React.ElementType<React.SVGProps<SVGSVGElement>>;
  title: string;
  value: ReactNode;
};

const createAuthorItem = (
  authorName: string | undefined,
  author: UserInformationUser | null | undefined,
  handleAuthorClick: () => void,
): InfoItem => {
  const authorElement = authorName ? (
    <div className="flex items-center gap-2">
      <IconUser className="text-neutrals-60 size-4" />
      <p className="text-type-minor">{authorName}</p>
    </div>
  ) : null;

  return {
    title: "Инициатор",
    value: (
      <UserInformation
        deletedUser={!authorElement}
        start
        trigger={<div onClick={handleAuthorClick}>{authorElement || authorName || "—"}</div>}
        user={author}
      />
    ),
  };
};

export const useNotificationInfoItems = ({
  author,
  authorName,
  body,
  date,
  handleAuthorClick,
}: {
  author?: UserInformationUser | null;
  authorName?: string;
  body: ReactNode;
  date: string;
  handleAuthorClick: () => void;
}): InfoItem[] =>
  useMemo(() => {
    const baseInfo: InfoItem[] = [{ icon: IconCalendarSchedule, title: "Дата и время", value: date }];
    const authorItem = createAuthorItem(authorName, author, handleAuthorClick);

    return [...baseInfo, { title: "Описание", value: <NotificationBody>{body}</NotificationBody> }, authorItem];
  }, [author, authorName, body, date, handleAuthorClick]);
